import { Button } from 'antd';
import { refreshDocumentTreeLevels } from 'slices/documentsActions';
import { PlusOutlined } from '@ant-design/icons';

import { useModal } from 'hooks/useModal';
import { useAppDispatch } from 'utilities/hooks';

interface DocumentsToolbarButtonCreateFolderProps {
    categoryId?: number | null;
    fetchData: () => void;
}

export const DocumentsToolbarButtonCreateFolder: React.FC<DocumentsToolbarButtonCreateFolderProps> = ({
    categoryId,
    fetchData,
}) => {
    const dispatch = useAppDispatch();
    const { openModal: openCategoryCreateModal } = useModal();

    return (
        <Button
            type="text"
            onClick={() =>
                openCategoryCreateModal(
                    'categoryCreateModal',
                    {
                        parent: categoryId,
                    },
                    {
                        onSubmit: () => {
                            fetchData();
                            dispatch(refreshDocumentTreeLevels([categoryId]));
                        },
                    },
                )
            }
            icon={<PlusOutlined />}
        >
            Create Folder
        </Button>
    );
};
